/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 1 = PerSecond 10 = PerTenSeconds 60 = PerOneMinute 300 = PerFiveMinutes 900 = PerFifteenMinutes 3600 = PerOneHour
 */
export type WafRateLimitTimeframeType = 1 | 10 | 60 | 300 | 900 | 3600;

export const WafRateLimitTimeframeType = {
  PerSecond: 1 as WafRateLimitTimeframeType,
  PerTenSeconds: 10 as WafRateLimitTimeframeType,
  PerOneMinute: 60 as WafRateLimitTimeframeType,
  PerFiveMinutes: 300 as WafRateLimitTimeframeType,
  PerFifteenMinutes: 900 as WafRateLimitTimeframeType,
  PerOneHour: 3600 as WafRateLimitTimeframeType,
};
